import React from 'react';
import ExchangeRatePopover from './ExchangeRatePopover';
import UserMenu from './UserMenu';
import styles from './AdminTopBar.module.scss';

export const ADMIN_TOPBAR_HEIGHT = 56;

interface AdminTopBarProps {
  organizationId: string | null | undefined;
  sidebarWidth: string;
}

const AdminTopBar: React.FC<AdminTopBarProps> = ({
  organizationId,
  sidebarWidth,
}) => {
  return (
    <header
      className={styles.bar}
      aria-label="Barra superior"
      style={{ left: sidebarWidth }}
    >
      <div className={styles.spacer} />
      <div className={styles.actions}>
        <ExchangeRatePopover organizationId={organizationId} />
        <UserMenu />
      </div>
    </header>
  );
};

export default AdminTopBar;
